import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import {useReadOnly} from "crqlar-react-common/dist/utils/hooks/users/useReadOnly";
import {
    useServerTableToolbarContext,
    useServerTableToolbarItemContext
} from "../ServerTableToolbarContext";
import {defineServerTableToolbarItem} from "../ServerTableToolbarItem";
import {serverTableControlIconSx, serverTableTextControlSx} from "../constants";
import type {ServerTableCreateProps} from "../types";

const ServerTableCreateComponent = ({
    label,
    onClick,
    disabled
}: ServerTableCreateProps) => {
    const {closePanel} = useServerTableToolbarContext();
    const toolbarItem = useServerTableToolbarItemContext();
    const readOnly = useReadOnly();

    // A read-only user can never create, on any list, in either the button or the
    // collapsed-menu presentation — regardless of what the screen passes as `disabled`.
    const createDisabled = disabled || readOnly;
    const create = () => {
        closePanel();
        toolbarItem.closeMenu();
        onClick();
    };

    if (toolbarItem.presentation === 'menu') {
        return (
            <MenuItem disabled={createDisabled} onClick={create}>
                <AddIcon fontSize="small" sx={{mr: 1}}/>
                {label}
            </MenuItem>
        );
    }

    return (
        <Button
            size="small"
            variant="contained"
            startIcon={<AddIcon sx={serverTableControlIconSx}/>}
            disabled={createDisabled}
            onClick={create}
            sx={{...serverTableTextControlSx, ml: 0.5}}
        >
            {label}
        </Button>
    );
};

export const ServerTableCreate = defineServerTableToolbarItem(ServerTableCreateComponent);
